import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VTooltip,{attrs:{"disabled":_vm.tooltip(_vm.kind) === '' || !_vm.show,"left":"","max-width":"150px","open-delay":"400"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c(VImg,_vm._g({staticStyle:{"border-radius":"5%"},attrs:{"src":_vm.cardPath(_vm.show ? _vm.kind : 'cardback'),"width":_vm.width}},on))]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltip(_vm.kind)))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }